import React from 'react';

export interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'title' | 'card' | 'custom';
  style?: React.CSSProperties;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  variant = 'text',
  style,
}) => {
  const variantClass =
    variant === 'title' ? 'ds-skeleton--title' : variant === 'card' ? 'ds-skeleton--card' : variant === 'text' ? 'ds-skeleton--text' : '';

  return (
    <div
      className={`ds-skeleton ${variantClass} ${className}`.trim()}
      style={style}
      aria-hidden="true"
    />
  );
};

export const SkeletonGroup: React.FC<{ lines?: number; className?: string }> = ({
  lines = 3,
  className = '',
}) => (
  <div className={className} style={{ display: 'flex', flexDirection: 'column', gap: 12 }} aria-hidden="true">
    <Skeleton variant="title" />
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} variant="text" style={{ width: i === lines - 1 ? '58%' : '100%' }} />
    ))}
  </div>
);

export default Skeleton;
